var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_vm._m(0),_c('div',{staticClass:"upload-files-container"},_vm._l((_vm.numberOfFilesToUpload),function(fileToUpload,index){return _c('div',{key:index},[_c('upload-file',{attrs:{"fileType":fileToUpload.fileType}})],1)}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-container"},[_c('h2',[_vm._v("Subida de archivos")])])
}]

export { render, staticRenderFns }